import { FilterListOutlined } from '@mui/icons-material';
import { Chip, Stack, Typography } from '@mui/material';

import useTranslate from 'hooks/useTranslate';
import type { TemplateType } from 'types';

export type TemplateTypeFilterValue = TemplateType | 'all';

const TYPE_FILTER_OPTIONS: { labelKey: string; value: TemplateTypeFilterValue }[] = [
    { labelKey: 'templateTypeAll', value: 'all' },
    { labelKey: 'templateTypeVisaApplication', value: 'visa-application' },
    { labelKey: 'templateTypeServiceAgreement', value: 'service-agreement' },
    { labelKey: 'templateTypeEligibility', value: 'eligibility' },
    { labelKey: 'templateTypeMilestones', value: 'milestones' },
    { labelKey: 'templateTypeEngagement', value: 'engagement' },
    { labelKey: 'templateTypeReferral', value: 'referral' },
    { labelKey: 'templateTypeSubcontractor', value: 'subcontractor' },
    { labelKey: 'templateTypeMsa', value: 'msa' },
    { labelKey: 'templateTypeRevenueSharing', value: 'revenue-sharing' },
    { labelKey: 'templateTypeNda', value: 'nda' },
    { labelKey: 'templateTypePreferredPartner', value: 'preferred-partner' },
];

const INDIVIDUAL_TYPES = new Set<TemplateTypeFilterValue>([
    'all',
    'visa-application',
    'service-agreement',
    'eligibility',
    'milestones',
    'engagement',
]);

interface TemplatesTypeFilterProps {
    value: TemplateTypeFilterValue;
    onChange: (value: TemplateTypeFilterValue) => void;
}

export function TemplatesTypeFilter({ value, onChange }: TemplatesTypeFilterProps) {
    const { translate } = useTranslate();

    return (
        <Stack
            direction="row"
            spacing={1}
            useFlexGap
            sx={{ flexWrap: 'wrap', alignItems: 'center', mb: 2.5 }}
        >
            <Stack
                direction="row"
                spacing={0.75}
                sx={{ alignItems: 'center', color: 'text.secondary' }}
            >
                <FilterListOutlined sx={{ fontSize: 18 }} />
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {translate('type')}
                </Typography>
            </Stack>
            {TYPE_FILTER_OPTIONS.map((opt) => {
                const isActive = value === opt.value;
                const isB2B = !INDIVIDUAL_TYPES.has(opt.value);

                return (
                    <Chip
                        key={opt.value}
                        size="small"
                        label={translate(opt.labelKey)}
                        onClick={() => onChange(opt.value)}
                        color={isActive ? 'primary' : 'default'}
                        variant={isActive ? 'filled' : 'outlined'}
                        sx={{
                            fontWeight: 500,
                            ...(isActive
                                ? {}
                                : isB2B
                                  ? {
                                        borderColor: 'secondary.main',
                                        color: 'secondary.main',
                                    }
                                  : {}),
                        }}
                    />
                );
            })}
        </Stack>
    );
}
